import type { HeaderFooterContext } from 'src/App/generated/graphql-types';
import { saveAccountInfo } from 'src/gql/client-side/actions';
import { getHeaderFooterContext as headerFooterQuery } from 'src/gql/server-side/queries-hg';
import { hirerGqlClient } from 'src/services/apollo/client/hirer-graph-client';
import type { AccountInfo } from 'src/types';

export const convertToAccountInfo = (
  context: HeaderFooterContext,
): AccountInfo => ({
  actAsSub: context?.identityContext?.act ? `0auth|${context?.user?.id}` : null,
  advertiserActivationPending:
    context?.advertiser?.isActivationPending ?? false,
  advertiserName: context?.advertiser?.name ?? '',
  billingId: context?.advertiser?.billingId ?? '',
  customerServiceView: context?.identityContext?.act?.isCsView ?? false,
  email: context?.identityContext?.email ?? '',
  hasMultipleAccounts: context?.advertiser?.hasMultipleAccounts ?? false,
  impersonatorUsername: context?.identityContext?.act?.operatorEmail ?? null,
  isAgency: context?.advertiser?.isAgency ?? false,
  name: context?.user?.name ?? '',
  permissionOptions: context?.advertiser?.permissionOptions ?? {
    canCreateJobs: false,
    canManageBrand: false,
    canManageCompanyProfile: false,
    canManageUsers: false,
    canPayInvoices: false,
    canViewInvoiceHistory: false,
    canViewManagerReports: false,
    canClaimCompanyProfile: false,
    canViewInsightsRoleReport: false,
  },
  showOnCreditHoldMessage:
    context?.advertiser?.showOnCreditHoldMessage ?? false,
  userId: context?.user?.id ? Number(context?.user?.id) : 0,
});

export const getHeaderFooterContext = async () => {
  try {
    const headerFooterContextResp = await hirerGqlClient.query({
      query: headerFooterQuery,
    });

    const {
      data: { headerFooterContext },
    } = headerFooterContextResp;

    saveAccountInfo(convertToAccountInfo(headerFooterContext));

    return headerFooterContext;
  } catch (error) {
    throw new Error(`Failed to fetch header footer context. Error: ${error}`);
  }
};
